import { useState } from 'react'
import { useSelector } from 'react-redux'

// antd
import {
    Col,
    Divider,
    Image,
    Row,
    Space,
    Spin,
    Tag,
    Typography,
    theme,
} from 'antd'

// components
import ModalProfile from '../../../components/modal'

// slices
import {
    profileState,
} from '../profile.slice'

// constants
import { fileTypes, videoTypes } from '../../../constants/mediaTypes'

// assets
import {
    CertificateIcon,
    CertificatesLogoIcon,
    NoCertificatesIcon,
    NoEducationIcon,
} from '../../../assets/icons'

// section
import NoIndividualContent from '../tabSection/noIndividualContent'

// modals
import ViewMultiMediaModal from '../modals/viewMultimediaModal'

// styles
import styles from '../profile.module.css'
import tabStyles from '../profileTabContent.module.css'
import { formatMonthYear } from '../../../utils/commonUtils'

function EducationTabContent() {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const {
        profileData: {
            data: { education, certificates },
        },
        status,
    } = useSelector(profileState)

    const [viewMediaCertificate, setViewMediaCertificate] = useState({
        open: false,
        file: {},
    })

    return (
        <>
            <div className={`${tabStyles.panel} ${tabStyles.hideDivider}`}>
                <Row align="middle" justify={'space-between'}>
                    <Title level={4} className={tabStyles.panelTitle}>
                        Education
                    </Title>
                    {/* {userProfile?.role?.roleName !== SUPER_ADMIN && (
                        <Button
                            props={{
                                text: 'Add Education',
                                onClick: () => {
                                    dispatch(
                                        switchProfileModal({
                                            name: 'education',
                                            open: true,
                                        })
                                    )
                                },
                            }}
                        />
                    )} */}
                </Row>
                <Spin spinning={status === 'loading' ? true : false}>
                    {status === 'loaded' && education?.length > 0 ? (
                        education.map((educationData, index) => (
                            <div
                                className={tabStyles.itemCard}
                                key={
                                    educationData?._id ||
                                    educationData?.eduInfo?.institute?.name ||
                                    index
                                }
                            >
                                <Row
                                    justify={'space-between'}
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <Col span={23}>
                                        <div className={tabStyles.itemMain}>
                                            <div className={tabStyles.logoBox}>
                                                {educationData?.eduInfo
                                                    ?.institute?.logo ? (
                                                    <Image
                                                        src={
                                                            educationData
                                                                ?.eduInfo
                                                                ?.institute
                                                                ?.logo
                                                        }
                                                        width={'100%'}
                                                        height={'100%'}
                                                        style={{
                                                            objectFit: 'cover',
                                                        }}
                                                        preview={false}
                                                    />
                                                ) : (
                                                    <div
                                                        className={
                                                            styles.educationSvgLogo
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <div className={tabStyles.itemBody}>
                                                <Row>
                                                    <Space>
                                                        {educationData?.eduInfo
                                                            ?.degree?.name && (
                                                            <Title
                                                                className={
                                                                    'titleSub'
                                                                }
                                                            >
                                                                {
                                                                    educationData
                                                                        ?.eduInfo
                                                                        ?.degree
                                                                        ?.name
                                                                }
                                                            </Title>
                                                        )}
                                                        <Text className="titleLight">
                                                            {!educationData?.isCompleted &&
                                                                `(Draft)`}
                                                        </Text>
                                                    </Space>
                                                </Row>
                                                <Space>
                                                    {educationData?.eduInfo
                                                        ?.institute?.name && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                educationData
                                                                    ?.eduInfo
                                                                    ?.institute
                                                                    ?.name
                                                            }
                                                        </Text>
                                                    )}
                                                    {educationData?.eduInfo
                                                        ?.institute?.name &&
                                                        educationData?.eduInfo
                                                            ?.location &&
                                                        '|'}
                                                    {educationData?.eduInfo
                                                        ?.location && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                educationData
                                                                    ?.eduInfo
                                                                    ?.location
                                                            }
                                                        </Text>
                                                    )}
                                                </Space>
                                                <Space>
                                                    {(() => {
                                                        const startLabel =
                                                            formatMonthYear(
                                                                educationData
                                                                    ?.eduInfo
                                                                    ?.start
                                                            )
                                                        const endLabel =
                                                            educationData
                                                                ?.eduInfo
                                                                ?.currentStudy
                                                                ? 'Present'
                                                                : formatMonthYear(
                                                                      educationData
                                                                          ?.eduInfo
                                                                          ?.end
                                                                  )
                                                        if (
                                                            !startLabel &&
                                                            !endLabel
                                                        )
                                                            return null
                                                        return (
                                                            <>
                                                                {startLabel ? (
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                token.fontSizeLG,
                                                                        }}
                                                                        className={
                                                                            'titleLight'
                                                                        }
                                                                    >
                                                                        {
                                                                            startLabel
                                                                        }
                                                                    </Text>
                                                                ) : null}
                                                                {startLabel &&
                                                                endLabel
                                                                    ? '-'
                                                                    : null}
                                                                {endLabel ? (
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                token.fontSizeLG,
                                                                        }}
                                                                        className={
                                                                            'titleLight'
                                                                        }
                                                                    >
                                                                        {
                                                                            endLabel
                                                                        }
                                                                    </Text>
                                                                ) : null}
                                                            </>
                                                        )
                                                    })()}
                                                </Space>
                                                {educationData?.skills?.length >
                                                    0 && (
                                                    <div>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                                fontWeight:
                                                                    token.fontWeightStrong,
                                                            }}
                                                        >
                                                            Skills
                                                        </Text>
                                                        <div
                                                            className={
                                                                tabStyles.tagWrap
                                                            }
                                                        >
                                                            {educationData?.skills.map(
                                                                (skill) => (
                                                                    <Tag
                                                                        key={
                                                                            skill?.label
                                                                        }
                                                                        color={
                                                                            token
                                                                                .colorPalette
                                                                                .baseColor
                                                                                .senary
                                                                        }
                                                                    >
                                                                        <Text
                                                                            style={{
                                                                                fontWeight:
                                                                                    token.fontWeightStrong,
                                                                            }}
                                                                        >
                                                                            {skill?.name?.toUpperCase()}
                                                                        </Text>
                                                                    </Tag>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {educationData?.tools?.length >
                                                    0 && (
                                                    <div>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSizeLG,
                                                                fontWeight:
                                                                    token.fontWeightStrong,
                                                            }}
                                                        >
                                                            Tools
                                                        </Text>
                                                        <Row
                                                            style={{
                                                                columnGap:
                                                                    '15px',
                                                                marginTop:
                                                                    '8px',
                                                            }}
                                                        >
                                                            {educationData?.tools.map(
                                                                (tool) => (
                                                                    <div
                                                                        key={
                                                                            tool?.label
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                styles.toolIconDefault
                                                                            }
                                                                            style={{
                                                                                border: `2px solid ${token.colorPalette.baseColor.tertiary}`,
                                                                            }}
                                                                        >
                                                                            <Image
                                                                                src={
                                                                                    tool?.logo
                                                                                }
                                                                                preview={
                                                                                    false
                                                                                }
                                                                                width={
                                                                                    '100%'
                                                                                }
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                width: '60px',
                                                                                whiteSpace:
                                                                                    'nowrap',
                                                                                overflow:
                                                                                    'hidden',
                                                                                textOverflow:
                                                                                    'ellipsis',
                                                                            }}
                                                                        >
                                                                            <Text
                                                                                style={{
                                                                                    marginTop:
                                                                                        '2px',
                                                                                    fontWeight:
                                                                                        token.fontWeightStrong,
                                                                                    textTransform:
                                                                                        'capitalize',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    tool?.name
                                                                                }
                                                                            </Text>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </Row>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {/* <Col span={1}>
                                        {userProfile?.role?.roleName !==
                                            SUPER_ADMIN && (
                                            <div
                                                className={tabStyles.editBtn}
                                                onClick={() => {
                                                    dispatch(
                                                        setDeleteModalTitle(
                                                            'education'
                                                        )
                                                    )
                                                    dispatch(
                                                        switchProfileModal({
                                                            name: 'education',
                                                            open: true,
                                                            mode: 'edit',
                                                        })
                                                    )
                                                    dispatch(
                                                        updatedDataProfile({
                                                            editData: {
                                                                step: 'education',
                                                                stepField:
                                                                    '_id',
                                                                stepFieldValue:
                                                                    educationData?._id,
                                                            },
                                                            _id: userProfile?._id,
                                                        })
                                                    )
                                                }}
                                            >
                                                <EditIcon />
                                            </div>
                                        )}
                                    </Col> */}
                                </Row>
                                {education?.length - 1 !== index && <Divider />}
                            </div>
                        ))
                    ) : status === 'loaded' ? (
                        <NoIndividualContent
                            content={{
                                key: 'education',
                                title: 'Education',
                                icon: <NoEducationIcon />,
                            }}
                        />
                    ) : (
                        status === 'loading' && <Spin />
                    )}
                </Spin>
                <Row
                    align="middle"
                    justify={'space-between'}
                    style={{
                        marginTop: '20px',
                    }}
                >
                    <Title level={4} className={tabStyles.panelTitle}>
                        Certificates
                    </Title>
                    {/* {userProfile?.role?.roleName !== SUPER_ADMIN && (
                        <Button
                            props={{
                                text: 'Add Certificate',
                                onClick: () => {
                                    dispatch(
                                        switchProfileModal({
                                            name: 'certificates',
                                            open: true,
                                        })
                                    )
                                },
                            }}
                        />
                    )} */}
                </Row>
                <Spin spinning={status === 'loading' ? true : false}>
                    {status === 'loaded' && certificates?.length > 0 ? (
                        certificates.map((certificatesData, index) => (
                            <div
                                className={tabStyles.itemCard}
                                key={
                                    certificatesData?._id ||
                                    certificatesData?.title ||
                                    index
                                }
                            >
                                <Row
                                    justify={'space-between'}
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <Col span={23}>
                                        <div className={tabStyles.itemMain}>
                                            {certificatesData?.fileLink
                                                ?.length > 0 ? (
                                                fileTypes.some((r) =>
                                                    certificatesData?.fileLink[0]
                                                        ?.toLowerCase()
                                                        .includes(r)
                                                ) ? (
                                                    <div
                                                        className={
                                                            tabStyles.logoBox
                                                        }
                                                    >
                                                        <Image
                                                            src={
                                                                certificatesData
                                                                    ?.fileLink[0]
                                                            }
                                                            preview={false}
                                                            style={{
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                setViewMediaCertificate(
                                                                    {
                                                                        open: true,
                                                                        file: {
                                                                            name: certificatesData?.title,
                                                                            description:
                                                                                certificatesData?.description,
                                                                            files: certificatesData?.fileLink,
                                                                        },
                                                                    }
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                ) : videoTypes.some((r) =>
                                                      certificatesData?.fileLink[0].includes(
                                                          r
                                                      )
                                                  ) ? (
                                                    <div
                                                        className={
                                                            tabStyles.logoBox
                                                        }
                                                    >
                                                        <video
                                                            src={
                                                                certificatesData
                                                                    ?.fileLink[0]
                                                            }
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit:
                                                                    'cover',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                setViewMediaCertificate(
                                                                    {
                                                                        open: true,
                                                                        file: {
                                                                            name: certificatesData?.title,
                                                                            description:
                                                                                certificatesData?.description,
                                                                            files: certificatesData?.fileLink,
                                                                        },
                                                                    }
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={
                                                            tabStyles.logoBox
                                                        }
                                                        onClick={() => {
                                                            setViewMediaCertificate(
                                                                {
                                                                    open: true,
                                                                    file: {
                                                                        name: certificatesData?.title,
                                                                        description:
                                                                            certificatesData?.description,
                                                                        files: certificatesData?.fileLink,
                                                                    },
                                                                }
                                                            )
                                                        }}
                                                    >
                                                        <iframe
                                                            src={`${certificatesData?.fileLink[0]}#view=fitH`}
                                                            title="PDF"
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            ) : (
                                                <div
                                                    className={
                                                        tabStyles.logoBox
                                                    }
                                                >
                                                    <CertificatesLogoIcon />
                                                </div>
                                            )}
                                            <div className={tabStyles.itemBody}>
                                                <Row>
                                                    <Space>
                                                        {certificatesData?.title && (
                                                            <Title
                                                                className={
                                                                    'titleSub'
                                                                }
                                                            >
                                                                {
                                                                    certificatesData?.title
                                                                }
                                                            </Title>
                                                        )}
                                                        <Text className="titleLight">
                                                            {!certificatesData?.isCompleted &&
                                                                `(Draft)`}
                                                        </Text>
                                                    </Space>
                                                </Row>
                                                <Space>
                                                    {certificatesData
                                                        ?.certificateProvider
                                                        ?.name && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                certificatesData
                                                                    ?.certificateProvider
                                                                    ?.name
                                                            }
                                                        </Text>
                                                    )}
                                                    {certificatesData
                                                        ?.certificateProvider
                                                        ?.name &&
                                                        certificatesData
                                                            ?.fieldOfStudy
                                                            ?.name &&
                                                        '|'}
                                                    {certificatesData
                                                        ?.fieldOfStudy
                                                        ?.name && (
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    token.fontSize,
                                                            }}
                                                        >
                                                            {
                                                                certificatesData
                                                                    ?.fieldOfStudy
                                                                    ?.name
                                                            }
                                                        </Text>
                                                    )}
                                                </Space>
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSizeLG,
                                                    }}
                                                    className={'titleLight'}
                                                >
                                                    {formatMonthYear(
                                                        certificatesData?.dateReceived
                                                    )}
                                                </Text>
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSize,
                                                    }}
                                                >
                                                    {
                                                        certificatesData?.description
                                                    }
                                                </Text>
                                            </div>
                                        </div>
                                    </Col>
                                    {/* <Col span={1}>
                                        {userProfile?.role?.roleName !==
                                            SUPER_ADMIN && (
                                            <div
                                                className={tabStyles.editBtn}
                                                onClick={() => {
                                                    dispatch(
                                                        setDeleteModalTitle(
                                                            'certificate'
                                                        )
                                                    )
                                                    dispatch(
                                                        switchProfileModal({
                                                            name: 'certificates',
                                                            open: true,
                                                            mode: 'edit',
                                                        })
                                                    )
                                                    dispatch(
                                                        updatedDataProfile({
                                                            editData: {
                                                                step: 'certificates',
                                                                stepField:
                                                                    '_id',
                                                                stepFieldValue:
                                                                    certificatesData?._id,
                                                            },
                                                            _id: userProfile?._id,
                                                        })
                                                    )
                                                }}
                                            >
                                                <EditIcon />
                                            </div>
                                        )}
                                    </Col> */}
                                </Row>
                                {certificates?.length - 1 !== index && (
                                    <Divider />
                                )}
                            </div>
                        ))
                    ) : status === 'loaded' ? (
                        <NoIndividualContent
                            content={{
                                key: 'certificates',
                                title: 'Certificates',
                                icon: <NoCertificatesIcon />,
                            }}
                        />
                    ) : (
                        status === 'loading' && <Spin />
                    )}
                </Spin>
            </div>
            <ModalProfile
                visibility={viewMediaCertificate?.open}
                handleCancel={() => {
                    setViewMediaCertificate({
                        open: false,
                        file: {},
                    })
                }}
                setMaxHeight={false}
                footer={false}
                icon={<CertificateIcon />}
                modalKey="viewVideo"
                modalTitle="Media"
                showTitle="Media"
                content={
                    <ViewMultiMediaModal
                        fileData={viewMediaCertificate?.file}
                    />
                }
            />
        </>
    )
}

export default EducationTabContent
